module.exports = __webpack_public_path__ + "static/media/19.158c2235.png";